import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TWrapperProps } from '../../models';

import { DesktopWrapper as Component } from './desktop-wrapper';

export const DesktopWrapper = createWidget<unknown, TWrapperProps>()(Component);
